import { atomWithKey as atom } from "./atomWithKey";
import { IAdditionalField, IModifiedPassengerName, ISaveServiceRequestDetailsResponse, ISaveServiceRequestResponse, ISelectedCategoryAndSubCategory, IServiceRequestCustom, ISubServiceRequestCategory } from "../Types/Interface/IServiceRequest";

export const selectedTripForServiceRequestAtom = atom<string[]>({
    key: "selectedTripForServiceRequestAtom",
    default: [],
});
export const serviceCategoriesAtom = atom<IServiceRequestCustom[]>({
    key: "serviceCategoriesAtom",
    default: [],
});
export const selectedCategoryAndSubCategoryAtom =
    atom<ISelectedCategoryAndSubCategory>({
        key: "selectedCategoryAndSubCategoryAtom",
        default: {
            category: "",
            subCategory: "",
        },
    });
export const subServiceCategoriesAtom = atom<ISubServiceRequestCategory[]>({
    key: "subServiceCategoriesAtom",
    default: [],
});
export const saveServiceRequestResponseAtom = atom<ISaveServiceRequestResponse | null>({
    key: "saveServiceRequestResponseAtom",
    default: null,
});
export const serviceRequestFormDataAtom = atom<{ [key: string]: string }>({
    key: "serviceRequestFormDataAtom",
    default: {},
});
export const submitRequestButtonDisabledAtom = atom<boolean>({
    key: "submitRequestButtonDisabledAtom",
    default: true,
});
export const serviceRequestModalAtom = atom<boolean>({
    key: "serviceRequestModalAtom",
    default: false,
});
export const serviceRequestTicketListAtom = atom<ISaveServiceRequestDetailsResponse[]>({
    key: "serviceRequestTicketListAtom",
    default: [],
});

export const openCommentAtom = atom<boolean>({
    key: "openCommentAtom",
    default: false,
});
export const openActionModalAtom = atom<boolean>({
    key: "openActionModalAtom",
    default: false,
});
export const actionTypeAtom = atom<string>({
    key: "actionTypeAtom",
    default: "",
});
export const activeTicketAtom = atom<ISaveServiceRequestDetailsResponse | null>({
    key: "activeTicketAtom",
    default: null,
});

export const lastVisitedPageForServiceRequestAtom = atom<string>({
    key: "lastVisitedPageForServiceRequestAtom",
    default: "",
});
export const additionalFieldsAtom = atom<IAdditionalField[]>({
    key: "additionalFieldsAtom",
    default: [],
});
export const modifiedPassengerNameAtom = atom<IModifiedPassengerName>({
    key: "modifiedPassengerNameAtom",
    default: {},
});